export default "__VITE_ASSET__eca0ea48__"